import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { changeDateFormat} from "../../../../Custom/Custom";
import { generateMultiplierReport } from "../../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel";
import messages from '../../../../assets/Messages.json';
import asiTitle from '../../../../asi.json';
import asiInputTitle from '../../../../titles.json';


function MultiplierReport() {

  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const storedLanguage = localStorage.getItem('language');
  const [down,setDown]=useState('download');
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const config = getAuthHeaders();


//get next Years 
const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    const nextYearShort = nextYear.toString().slice(-2);
    return `${year}-${nextYearShort}`;
    };


useEffect(() => {
      
    const getYearList = () => {
    setYears(getAllYears());
    };
    getYearList();
}, []);
  

//get Years 
  const getAllYears = () => {
    // const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = new Date().getFullYear() - 2; year >= 2013; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };  



  const downloadStaticMultiplierXlsx = async () => {
    const fileUrl = `pdf/ASI_Multiplier.xlsx`;
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("File not found");
      }
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = "ASI_Multiplier.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error(error);
      toast.error("File not found", messages.COLOR_RED);
    } finally {
      showLoading(false);
    }
  };




// Function to generate Excel file using mapped data
const handleGenerateExcel = async () => {
   
    if (!yearName) {
      toast.error("Please select a Survey Year", messages.COLOR_RED);
      return;
    }

    if (String(yearName) === "2023") {
      downloadStaticMultiplierXlsx();
      return false;
    }
try{


    let postData = {
        survey_year: yearName,
        downloadType: "download"
      }
    showLoading(true);
    let excelRowData=[];
      const response = await axios.post(`${API_URL}api/asi/reports/HQReports/asiMultiplierReport`, postData, config);
        const allData = response.data.data.asiMultiplierReport;
      if (allData && allData.length > 0) {
     
        let NoofallunitsinFramecensussamplesector = allData.reduce((accum,item) => accum + item.NoofallunitsinFramecensussamplesector, 0)
        let NoofallunitsinCensussector = allData.reduce((accum,item) => accum + item.NoofallunitsinCensussector, 0)
        let NoofsampleSectorunitsintheFrameCol34 = allData.reduce((accum,item) => accum + item.NoofsampleSectorunitsintheFrameCol34, 0)
        let CentralSample = allData.reduce((accum,item) => accum + item.CentralSample, 0)
        let StateSample = allData.reduce((accum,item) => accum + item.StateSample, 0)
        let TotalNoofunitsSelectedintheSampleSectorCol67 = allData.reduce((accum,item) => accum + item.TotalNoofunitsSelectedintheSampleSectorCol67, 0)
        let TotalNoofunitsSurveyedCol810 = allData.reduce((accum,item) => accum + item.TotalNoofunitsSurveyedCol810, 0)
        let CasualtyCasesCol578 = allData.reduce((accum,item) => accum + item.CasualtyCasesCol578, 0)
       
    excelRowData=allData.map(item => [
            item.DistrictCode,
            item.Industrycode,
            item.NoofallunitsinFramecensussamplesector,
            item.NoofallunitsinCensussector,
            item.NoofsampleSectorunitsintheFrameCol34,
            item.CentralSample,
            item.StateSample,
            item.TotalNoofunitsSelectedintheSampleSectorCol67,
            item.TotalNoofunitsSurveyedCol810,
            item.CasualtyCasesCol578,
            item.Multiplier,
            
          ]);

          excelRowData[excelRowData.length]=['TOTAL','',NoofallunitsinFramecensussamplesector,
            NoofallunitsinCensussector,
            NoofsampleSectorunitsintheFrameCol34,
            CentralSample,
            StateSample,
            TotalNoofunitsSelectedintheSampleSectorCol67,
            TotalNoofunitsSurveyedCol810,
            CasualtyCasesCol578,
            ''
            
          ]
   }



   let excelFileName = `ASI_Multiplier`;
   const excelObjectData = {
      fileName: excelFileName,
      reportType: excelFileName,
      fileType: 'xls',
      sheetName: 'ASIMultiplier',
      firstRowMergeCells: "A1:K1",
      firstRowExportDate:  changeDateFormat(new Date()),
      secondRowMergeCells: "A2:K2",
      secondRowText: `Multiplier of ASI ${yearName}`,
//       headerEnglishColumns: [
//          'District code',
//          'Industry code (NIC 4-digit)', 
//          'No of all units in Frame    (census + sample sector)',
//          'No of all units in Census sector',
//          'No.of sample Sector units in the Frame (col.3- col.4) (N)',
//          'Central Sample',
//          'State Sample',
//          'Total No.of units Selected in the  Sample Sector (col.6+ col.7) (n)',
//          "Total No.of units Surveyed (n') (col.8-col.10)'",
//          "Casualty Cases (Status Code 5, 7 & 8)",
//          "Multiplier (col. 5 / col.9) N / n' (0.0000)"
//    ],
    excelRowData:excelRowData
   };
   generateMultiplierReport(excelObjectData);

  } catch (error) {
    console.error(error);
    toast.error('An error occurred while processing your request.', messages.COLOR_RED);
} finally {
  showLoading(false);
}
    
  };

  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.MULTIPLIER_REPORT : asiTitle.en.MULTIPLIER_REPORT }} />
              </h4>
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-2 col-sm-3 mb-3">
                  <label className="fw-bold h6"> {storedLanguage === 'hi' ? asiInputTitle.hi.SURVEY_YAER : asiInputTitle.en.SURVEY_YAER}</label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={(e)=>(setYearName(e.target.value))}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {getNextYear(ele)}
                        </option>
                      ))}
                  </select>
                </div>

             
                
            {/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-3 pt-0 pt-sm-3"> */}
            {/* <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
             <div className="form-check form-check-inline me-2">
                <label className="form-check-label" htmlFor="radio1">Download</label>
                    <input 
                        type="radio" 
                        onChange={(e)=>(setDown(e.target.value))}  
                        className="form-check-input" 
                        id="radio1" 
                        name="download" 
                        value="download" 
                        checked={down==='download'}
                    />
                     
                </div>
                <div className="form-check form-check-inline">
                <label className="form-check-label" htmlFor="radio2" >Update and Download</label>
                    <input 
                        type="radio"    
                        onChange={(e)=>(setDown(e.target.value))}  
                        className="form-check-input" 
                        id="radio2" 
                        name="update_and_download" 
                        value="update_and_download"
                        checked={down==='update_and_download'}
                    />
                  
                </div>
            </div> */}

                <div className="col-xl-2 col-lg-5 col-md-4 col-sm-3 col-6 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default MultiplierReport